import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autoplay"
export default class extends Controller {
  static values = {
    mobileOnly: Boolean
  }
  connect() {
    if (this.mobileOnlyValue && !this.isMobileDevice()) {
      return
    }

    if ('IntersectionObserver' in window) {
      this.initializeAutoplay(this.element)
    } 
    else {
      console.warn("IntersectionObserver is not supported in this browser.")
    }
  }

  isMobileDevice() {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0
    const isSmallScreen = window.innerWidth <= 768
    const isTabletDevice = /iPad|Tablet|PlayBook|Silk|Android(?!.*Mobile)/i.test(navigator.userAgent)

    return isTouchDevice || isSmallScreen || isTabletDevice
  }

  initializeAutoplay(video) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.play().catch(e => console.error("Error attempting to play video:", e))
        } else {
          entry.target.pause()
        }
      })
    }, { threshold: 0.1 })

    observer.observe(video)
  }
}
